import React from "react"
import { useTranslation } from "react-i18next"

import Accordion from "../../components/Accordion/Accordion"

import styles from "./Summary.module.scss"

const SummaryDetail = ({ areasOrdered, configuratorAreas, values }) => {
  const { t, i18n } = useTranslation()
  const allBooleanAndFalse = (variables) => Object.entries(variables).every(
    ([id, variable]) =>
      variable.VISUALIZACION === "BOOLEANO" && values[id] === false
  );

  return (
    <>
      {areasOrdered?.length > 0 &&
        configuratorAreas &&
        values &&
        areasOrdered.map(area => (
          <Accordion
            id={area}
            key={area}
            title={configuratorAreas[area].NOMBRE[i18n.language]}
            summary={true}
            values={values}
          >
            <>
              {Object.entries(configuratorAreas[area].HIJOS).map(([hijoId, hijo]) => (
                <React.Fragment key={hijoId}>
                  <div className={styles.subAreaTitle}>
                    <h3>{hijo.NOMBRE[i18n.language]}</h3>
                  </div>

                  {allBooleanAndFalse(hijo.VARIABLES) ? (
                    <div className={styles.valueTitle}>{t("Not selected")}</div>
                  ) : (
                    Object.entries(hijo.VARIABLES).map(([variableId, variable]) => {
                      if (variable.VISUALIZACION !== "BOOLEANO") {
                        return (
                          <div key={variableId} className={styles.valueTitle}>
                            {variable?.VALORES?.[values[variableId]]?.TEXTO?.[i18n.language]}
                          </div>
                        );
                      } else if (values[variableId]) {
                        return (
                          <div key={variableId} className={styles.valueTitle}>
                            {variable?.NOMBRE?.[i18n.language]}
                          </div>
                        );
                      }
                      return null;
                    })
                  )}
                </React.Fragment>
              ))}
            </>
          </Accordion>
        ))}
    </>
  )
}

export default SummaryDetail
